import { virtualSummaryDto } from '../dto/virtualSummaryDto';
import { virtualTableDataViewModel } from '../views/virtualTableDataViewModel';
import { averageVMTransformer } from './averageVMTransformer';
import { guestOSCountTransformer } from './guestOSCountTransformer';
import { MemoryTransformer } from './memoryTransformer';
import { vcpuTransformer } from './vcpuTransformer';
import { capacityTransformer } from './capacityTransformer';
import { physicalVMsTransformer } from './physicalVMsTransformer';
import { physicalHostsTransformer } from './physicalHostsTransformer';
import { physicalHostsStatsTransformer } from './physicalHostsStatsTransformer';

export class virtualResponseTransformer {
  public static from(response: virtualSummaryDto): virtualTableDataViewModel {
    return <virtualTableDataViewModel>{
     averageVMDataArray:
        response.averageVM != null ? averageVMTransformer.from(response.averageVM) : null,
      guestOSCountDataArray:
        response.guestOSCounts != null
          ? guestOSCountTransformer.from(response.guestOSCounts)
          : null,
      memoryDataArray: response.memory != null ? MemoryTransformer.from(response.memory) : null,
      vcpuDataArray: response.vcpu != null ? vcpuTransformer.from(response.vcpu) : null,
      capacityDataArray:
        response.capacity != null ? capacityTransformer.from(response.capacity) : null,
      physicalVMsArray:
        response.physical != null ? physicalVMsTransformer.from(response.physical) : null,
      physicalHostsArray:
        response.physical != null ? physicalHostsTransformer.from(response.physical) : null,
      physicalHostsStatsArray:
        response.physical != null ? physicalHostsStatsTransformer.from(response.physical) : null
    };
  }
}
